export default __webpack_public_path__ + "static/poster-c85f5e844c71606f861ef2e595516c24.png";